import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Income14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9 5.5C9 6.05228 8.55228 6.5 8 6.5C7.44772 6.5 7 6.05228 7 5.5C7 4.94772 7.44772 4.5 8 4.5C8.55228 4.5 9 4.94772 9 5.5Z'
      fill='currentColor'
    />
    <path d='M9.75 4H11.25V7H9.75V4Z' fill='currentColor' />
    <path d='M6.25 7L6.25 4L4.75 4V7H6.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.25 1.25H13.75V9.75H2.25V1.25ZM3.75 2.75V8.25H12.25V2.75H3.75Z'
      fill='currentColor'
    />
    <path d='M1.75 10.25V4H0.25V11.75H11V10.25H1.75Z' fill='currentColor' />
  </Svg>
);

Income14.displayName = 'Income14';
export default Income14;
